import React, { Component } from 'react';
import { TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';
import { Box, View } from 'modules/styled';
import CommunityListItem from 'modules/community/communityListItem.component';
import { RateLimitWarning } from 'modules/comment/ratelimitWarning';

class CommunitySelection extends Component {
  static propTypes = {
    actions: PropTypes.object,
    community: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      input: '',
      inputFocused: false,
    };
  }

  setCommunity(community) {
    this.props.actions.setCommunity(community.slug);
  }

  render() {
    const { community } = this.props;
    const { communities } = community;
    if (!communities) {
      return null;
    }
    if (!Object.values(communities)) {
      return null;
    }
    return (
      <View>
        <Box sx={{ mb: 2 }} />
        {Object.values(communities).map((c) => {
          const active = community.active === c.slug;
          return (
            <Box key={c.slug}>
              {active && <RateLimitWarning sx={{ mt: 0 }} postType={'post'} />}
              <TouchableOpacity
                onPress={() => requestAnimationFrame(() => this.setCommunity(c))}
              >
                <Box sx={{ py: 1, px: 2, bg: active ? 'blue' : null }}>
                  <CommunityListItem community={c} c={active ? `white` : null} />
                </Box>
              </TouchableOpacity>
            </Box>
          );
        })}
      </View>
    );
  }
}

export default CommunitySelection;
